export const PWA_MEANINGFUL_EARN_EVENT = 'rewardbloom:pwa-meaningful-earn';
export const PWA_INSTALL_ACCEPTED_EVENT = 'rewardbloom:pwa-install-accepted';

const MEANINGFUL_EARN_KEY = 'rewardbloom.pwa.meaningful-earn';
const INSTALL_OBSERVED_KEY = 'rewardbloom.pwa.install-observed';

type NavigatorWithStandalone = Navigator & {
  standalone?: boolean;
};

export type PwaDisplayMode = 'standalone' | 'browser';

export function isPwaStandalone(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as NavigatorWithStandalone).standalone === true
  );
}

export function isIosSafari(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const userAgent = window.navigator.userAgent;
  const isIos =
    /iPad|iPhone|iPod/.test(userAgent) || (userAgent.includes('Macintosh') && window.navigator.maxTouchPoints > 1);
  const isWebKit = /WebKit/.test(userAgent);
  const isAlternativeBrowser = /CriOS|FxiOS|EdgiOS|OPiOS/.test(userAgent);

  return isIos && isWebKit && !isAlternativeBrowser;
}

export function notifyPwaInstallAccepted(): void {
  window.dispatchEvent(new Event(PWA_INSTALL_ACCEPTED_EVENT));
}

export function hasObservedPwaInstallation(): boolean {
  try {
    return window.localStorage.getItem(INSTALL_OBSERVED_KEY) === 'true';
  } catch {
    return false;
  }
}

export function markPwaInstallationObserved(): void {
  try {
    window.localStorage.setItem(INSTALL_OBSERVED_KEY, 'true');
  } catch {
    // The authenticated tracker can still use the current event or standalone mode.
  }
}

export function clearObservedPwaInstallation(): void {
  try {
    window.localStorage.removeItem(INSTALL_OBSERVED_KEY);
  } catch {
    // The server update is already complete, so no retry marker is required.
  }
}

export function getPwaDisplayMode(): PwaDisplayMode {
  return isPwaStandalone() ? 'standalone' : 'browser';
}

export function hasMeaningfulEarn(): boolean {
  try {
    return window.localStorage.getItem(MEANINGFUL_EARN_KEY) === 'true';
  } catch {
    return false;
  }
}

export function markPwaMeaningfulEarn(source: string): void {
  try {
    window.localStorage.setItem(MEANINGFUL_EARN_KEY, 'true');
  } catch {
    // Storage may be unavailable in private browsing. The in-page event still
    // lets the current session become eligible.
  }

  window.dispatchEvent(new CustomEvent(PWA_MEANINGFUL_EARN_EVENT, { detail: { source } }));
}
